var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          selection: _vm.selection,
          "before-reset-search": _vm.beforeResetSearch,
          "before-query-search": _vm.beforeQuerySearch,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c("BjFormItemCode", {
                      attrs: {
                        placeholder: _vm.$t("BusinessPurchaseOrder2.code"),
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleQuery.apply(null, arguments)
                        },
                      },
                      model: {
                        value: _vm.queryParams.code,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryParams, "code", $$v)
                        },
                        expression: "queryParams.code",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseEntryComView.statusMeaning"
                          ),
                          prop: "status",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            placeholder: _vm.$t(
                              "BusinessPurchaseEntryComView.statusMeaning"
                            ),
                            multiple: "",
                            "option-list": _vm.statusOptionList,
                          },
                          model: {
                            value: _vm.statusList,
                            callback: function ($$v) {
                              _vm.statusList = $$v
                            },
                            expression: "statusList",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                !_vm.$store.getters.cusId
                  ? _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "BusinessAfterCsgReturn.table.cusName"
                              ),
                            },
                          },
                          [
                            _c("BjSelectLov", {
                              attrs: {
                                "option-list": _vm.customerList,
                                placeholder: _vm.$t("customerNameText"),
                              },
                              on: { change: _vm.handleQuery },
                              model: {
                                value: _vm.queryParams.cusId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "cusId", $$v)
                                },
                                expression: "queryParams.cusId",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("BusinessPurchaseOrder2.Unit"),
                          prop: "shippingMethod",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            placeholder: _vm.$t("BusinessPurchaseOrder2.Unit"),
                            "option-list": _vm.SHIPPING_METHODS,
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.shippingMethod,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "shippingMethod", $$v)
                            },
                            expression: "queryParams.shippingMethod",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessBatchInventoryQuery.table.skuCode"
                          ),
                          prop: "skuCode",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t(
                              "BusinessBatchInventoryQuery.table.skuCode"
                            ),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.skuCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "skuCode", $$v)
                            },
                            expression: "queryParams.skuCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.isOpen
                  ? _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "BusinessPurchaseOrder2.dialog.arriveDate"
                              ),
                            },
                          },
                          [
                            _c("BjDateTimerPicker", {
                              attrs: {
                                "tip-show": false,
                                placeholder: _vm.$t(
                                  "BusinessPurchaseOrder2.dialog.arriveDate"
                                ),
                              },
                              model: {
                                value: _vm.queryParams.deliveryTimeEnd,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryParams,
                                    "deliveryTimeEnd",
                                    $$v
                                  )
                                },
                                expression: "queryParams.deliveryTimeEnd",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.isOpen
                  ? _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "BusinessPurchaseOrderDetail.finishTime"
                              ),
                            },
                          },
                          [
                            _c("BjDateRangePicker", {
                              attrs: {
                                placeholder: _vm.$t(
                                  "BusinessPurchaseOrderDetail.finishTime"
                                ),
                              },
                              model: {
                                value: _vm.queryParamsTime_finish,
                                callback: function ($$v) {
                                  _vm.queryParamsTime_finish = $$v
                                },
                                expression: "queryParamsTime_finish",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c("BjFormItemCode", {
                      attrs: {
                        placeholder: _vm.$t("BusinessPurchaseOrder2.container"),
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleQuery.apply(null, arguments)
                        },
                      },
                      model: {
                        value: _vm.queryParams.containerId,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryParams, "containerId", $$v)
                        },
                        expression: "queryParams.containerId",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return [
                _c(
                  "el-col",
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission:BusinessPurchaseOrderCsgAdd",
                            arg: "BusinessPurchaseOrderCsgAdd",
                          },
                        ],
                        staticClass: "main-btn",
                        attrs: { type: "primary" },
                        on: { click: _vm.onAdd },
                      },
                      [_vm._v(_vm._s(_vm.$t("addText")))]
                    ),
                    _c("BjFrontendExport", {
                      attrs: {
                        disabled: !_vm.selectedRows.length,
                        type: "primary",
                        "label-list": _vm.exportLabelList,
                        rows: _vm.selectedRows,
                        "file-name": _vm.exportFileName,
                        worksheet: "worksheet1",
                      },
                      on: { "export-success": _vm.resetAfterExport },
                    }),
                    _vm.isOpen
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName:
                                  "v-permission:BusinessPurchaseOrderDelete",
                                arg: "BusinessPurchaseOrderDelete",
                              },
                            ],
                            attrs: { type: "primary" },
                            on: { click: _vm.onDeleteSelected },
                          },
                          [_vm._v(_vm._s(_vm.$t("delText")))]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    false
                                      ? void 0
                                      : col.prop === "code"
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "link",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onDetail(row)
                                                },
                                              },
                                            },
                                            [_vm._v(_vm._s(row[col.prop]))]
                                          ),
                                          _c("BjCopyIcon", {
                                            attrs: { copy: row[col.prop] },
                                          }),
                                        ]
                                      : col.prop === "thirdCode"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                row.shippingMethod ==
                                                  "Container"
                                                  ? row.containerId
                                                  : row.thirdCode
                                              )
                                            ),
                                          ]),
                                        ]
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                row[col.prop],
                                                row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "permission",
                                            rawName:
                                              "v-permission:BusinessPurchaseOrderCsgAdminDetail",
                                            arg: "BusinessPurchaseOrderCsgAdminDetail",
                                          },
                                        ],
                                        staticClass: "view-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onDetail(row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "BusinessPurchaseOrderList.View"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    row.status === "New"
                                      ? _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "permission",
                                                rawName:
                                                  "v-permission:BusinessPurchaseOrderCsgAdminDetail",
                                                arg: "BusinessPurchaseOrderCsgAdminDetail",
                                              },
                                            ],
                                            staticClass: "delete-btn",
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onEdit(row)
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$t("editText")))]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }